import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'toro-maya-api-key-dialog',
    templateUrl: './maya-api-key-dialog.component.html',
    styleUrls: ['./maya-api-key-dialog.component.less']
})
export class MayaApiKeyDialogComponent {

    @Output() setApiKey = new EventEmitter<string>();
    @Output() cancelClick = new EventEmitter();

    @Input() apiKey: string;

    // =========================================================================================================================================================
    // Ctor and Lifecycle Hooks
    // =========================================================================================================================================================

    constructor() { }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    onSetApiKey() {
        this.setApiKey.emit(this.apiKey);
    }

    onCancelDialog() {
        this.cancelClick.emit();
    }

}
